<template>
  <div class="results-container">
    <router-link to="/">
      <img src="@/assets/bobw-logo-no-name.png" alt="BoBW Logo no name" class="small-logo" />
    </router-link>

    <h2>🎶 Song Rankings</h2>

    <!-- Show Loading Message -->
    <p v-if="loading" class="loading">⏳ Loading results...</p>

    <!-- Show Error Message -->
    <p v-if="error" class="error">{{ error }}</p>

    <!-- Show Results -->
    <div v-if="results.length">
      <div v-for="(member, index) in results" :key="index" class="member-section">
        <h3>{{ member.bandMember }}'s Songs</h3>
        <table>
          <thead>
            <tr>
              <th>Song Title</th>
              <th>Artist</th>
              <th>Avg Rank</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(song, songIndex) in member.songs" :key="songIndex">
              <td>{{ song.songTitle }}</td>
              <td>{{ song.artist }}</td>
              <td>{{ song.averageRank.toFixed(1) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- If No Results -->
    <p v-else-if="!loading && !error" class="no-results">😔 No results available yet.</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      results: [],
      error: "",
      loading: true
    };
  },
  async mounted() {
    await this.fetchResults();
  },
  methods: {
    async fetchResults() {
      try {
        console.log("Fetching results...");
        const response = await fetch("https://zmrukyt38a.execute-api.us-west-2.amazonaws.com/v1/get-results", {
          method: "GET",
          headers: { "Content-Type": "application/json" }
        });

        console.log("Raw response:", response);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Read response as text before parsing
        const resultText = await response.text();
        console.log("Raw JSON String:", resultText);

        if (!resultText) {
          throw new Error("Empty response from API");
        }

        // Safely parse JSON
        const result = JSON.parse(resultText);
        console.log("Parsed JSON:", result);

        // Ensure structure is correct
        if (result.success && Array.isArray(result.results)) {
          this.results = result.results;
          console.log("✅ Successfully loaded results:", this.results);
        } else {
          throw new Error("API returned unexpected format.");
        }

      } catch (error) {
        console.error("❌ Error fetching results:", error);
        this.error = "Failed to fetch results.";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* 🔹 Page Container */
.results-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #121212; /* Dark Theme */
  color: white;
  text-align: center;
  padding: 20px;
}

/* 🔹 Member Sections */
.member-section {
  width: 100%;
  max-width: 600px;
  margin-bottom: 20px;
  background: #1e1e1e;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 2px 2px 10px rgba(255, 255, 255, 0.1);
}

.small-logo {
  width: 50px;
  height: auto;
  position: absolute;
  top: 20px;
  left: 20px;
  cursor: pointer;
}

/* 🔹 Tables */
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

th, td {
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #444;
}

/* 🔹 Table Headers */
th {
  background-color: #e63946;
  color: white;
  border-radius: 5px;
}

/* 🔹 Table Rows */
tr:nth-child(even) {
  background-color: #222;
}

/* 🔹 Messages */
.loading {
  font-size: 18px;
  color: #f4a261;
}

.error {
  font-size: 18px;
  color: #ff5252;
}

.no-results {
  font-size: 18px;
  color: #f4a261;
}
</style>
